var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:[
      _vm.styles.textarea,
      { 'border-red-500 hover:border-red-500 focus:border-red-600 text-red-600': _vm.hasErrors }
      ],domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keyup":function($event){_vm.$root !== undefined && _vm.$root.hasOwnProperty('stopArrows') ? _vm.$root.stopArrows($event) : ''}}})
}
var staticRenderFns = []

export { render, staticRenderFns }